import { VBtn } from 'vuetify/lib/components/VBtn';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VProgressCircular } from 'vuetify/lib/components/VProgressCircular';

var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "div",
    { attrs: { "data-qa": "doctor-appointment-restrictions" } },
    [
      _c(
        _setup.CoreDialog,
        {
          attrs: {
            "data-qa": "doctor-appointment-restrictions-loading",
            size: "sm",
          },
          model: {
            value: _setup.isLoadingDialogOpen,
            callback: function ($$v) {
              _setup.isLoadingDialogOpen = $$v
            },
            expression: "isLoadingDialogOpen",
          },
        },
        [
          _c(
            "div",
            {
              staticClass:
                "d-flex flex-column align-center justify-center py-10",
            },
            [
              _c(VProgressCircular, {
                attrs: {
                  width: "2.5",
                  size: "42",
                  color: "primary",
                  indeterminate: "",
                },
              }),
            ],
            1
          ),
        ]
      ),
      _vm._v(" "),
      _c(
        _setup.isMobile ? _setup.CoreBottomSheet : _setup.CoreDialog,
        _vm._b(
          {
            tag: "component",
            attrs: { "data-qa": "doctor-appointment-restrictions-modal" },
            scopedSlots: _vm._u([
              {
                key: "actions",
                fn: function () {
                  return [
                    _c(
                      VBtn,
                      {
                        staticClass: "branding-btn branding-btn--primary",
                        attrs: {
                          "data-qa": "modal-actions-btn-close",
                          color: "primary",
                          block: "",
                          depressed: "",
                        },
                        on: {
                          click: function ($event) {
                            _setup.isContentDialogOpen = false
                          },
                        },
                      },
                      [
                        _vm._v(
                          "\n        " +
                            _vm._s(_setup.t("Понятно", _setup.l10nOptions)) +
                            "\n      "
                        ),
                      ]
                    ),
                  ]
                },
                proxy: true,
              },
            ]),
            model: {
              value: _setup.isContentDialogOpen,
              callback: function ($$v) {
                _setup.isContentDialogOpen = $$v
              },
              expression: "isContentDialogOpen",
            },
          },
          "component",
          _setup.isMobile
            ? {}
            : {
                size: "md",
                title: _setup.title,
                divider: true,
                "content-class": "doctor-appointment-restrictions-modal",
              },
          false
        ),
        [
          _setup.isMobile
            ? _c("div", { staticClass: "text-h6 text--text pt-2 pb-4" }, [
                _vm._v("\n      " + _vm._s(_setup.title) + "\n    "),
              ])
            : _vm._e(),
          _vm._v(" "),
          _c("div", { staticClass: "d-flex flex-column overflow-y-hidden" }, [
            _vm.lpuName
              ? _c(
                  "div",
                  { staticClass: "d-flex align-center py-1 mb-4" },
                  [
                    _c(
                      VIcon,
                      {
                        staticClass: "mr-4",
                        attrs: { color: "icon-secondary" },
                      },
                      [_vm._v("\n          ui-icon-clinic\n        ")]
                    ),
                    _vm._v(" "),
                    _c(
                      "span",
                      { staticClass: "text-body-1 text-break text--text" },
                      [_vm._v(_vm._s(_vm.lpuName))]
                    ),
                  ],
                  1
                )
              : _vm._e(),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "custom-scroll overflow-y-auto text--text" },
              _vm._l(_setup.restrictionsGroups, function (group, index) {
                return _c(
                  "div",
                  {
                    key: `${group.title}-${index}`,
                    class: { "mt-4": index !== 0 },
                  },
                  [
                    _c(
                      "div",
                      { staticClass: "text-subtitle-1 text-break mb-1" },
                      [
                        _vm._v(
                          "\n            " +
                            _vm._s(group.title) +
                            "\n          "
                        ),
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "ul",
                      _vm._l(
                        group.restrictions,
                        function (restriction, restrictionIndex) {
                          return _c(
                            "li",
                            {
                              key: restrictionIndex,
                              staticClass: "text-body-1 text-break",
                            },
                            [
                              _vm._v(
                                "\n              " +
                                  _vm._s(restriction) +
                                  "\n            "
                              ),
                            ]
                          )
                        }
                      ),
                      0
                    ),
                  ]
                )
              }),
              0
            ),
          ]),
        ]
      ),
      _vm._v(" "),
      _c(
        _setup.CoreDialog,
        {
          attrs: {
            "data-qa": "doctor-appointment-restrictions-error",
            size: "sm",
            title: _setup.errorTitle,
            divider: "",
          },
          scopedSlots: _vm._u([
            {
              key: "actions",
              fn: function () {
                return [
                  _c(
                    VBtn,
                    {
                      staticClass: "branding-btn branding-btn--primary",
                      attrs: { color: "primary", block: "", depressed: "" },
                      on: { click: _setup.reloadPage },
                    },
                    [
                      _vm._v(
                        "\n        " +
                          _vm._s(_setup.t("Обновить", _setup.l10nOptions)) +
                          "\n      "
                      ),
                    ]
                  ),
                ]
              },
              proxy: true,
            },
          ]),
          model: {
            value: _setup.isErrorDialogOpen,
            callback: function ($$v) {
              _setup.isErrorDialogOpen = $$v
            },
            expression: "isErrorDialogOpen",
          },
        },
        [
          _c("div", { staticClass: "text-body-1 text-secondary--text" }, [
            _vm._v("\n      " + _vm._s(_setup.errorText) + "\n    "),
          ]),
        ]
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }